export const getViewportIdFromElement = (element: HTMLElement) => {
  const { id } = element;
  return Number(id.substring(id.indexOf("-") + 1, id.length));
};
